﻿import document from 'document';

const lastMenuItem = document.querySelector('#zen-account-menu .zen-login-cta__menu-list .zen-login-cta__menu-item:last-child button');
const firstMenuItem = document.querySelector('#zen-account-menu .zen-login-cta__menu-list .zen-login-cta__menu-item a');

export const zenLoginCtaMenu = (selectors) => {
    const menu = document.querySelector(selectors.menu);
    const button = document.querySelector(selectors.button);

    const _toggleMenuVisibility = () => {
        menu.classList.toggle(selectors.menuOpen);
    };

    const _toggleOptionsVisibility = function (e) {
        e.stopPropagation();

        document.addEventListener('keydown', _handleKeyPress);
        document.addEventListener('click', _handleClick);

        const isOpen = button.classList.contains(selectors.buttonOpen);

        if (isOpen) {
            this.classList.add(selectors.buttonClosed);
            this.classList.remove(selectors.buttonOpen);
            this.setAttribute("aria-expanded", "false")
        } else {
            this.classList.remove(selectors.buttonClosed);
            this.classList.add(selectors.buttonOpen);
            this.setAttribute("aria-expanded", "true")
        }
        _toggleMenuVisibility();
    };

    const _closeLoginOptions = () => {
        if (menu.classList.contains(selectors.menuOpen.replace(/\./g,''))) {
            menu.classList.remove(selectors.menuOpen);
            button.classList.remove(selectors.buttonOpen);
            button.classList.add(selectors.buttonClosed);
            button.setAttribute("aria-expanded", "false");
        }

        document.removeEventListener('click', _handleClick);
        document.removeEventListener('keydown', _handleKeyPress);
    };

    const _toggleMobileOptionsVisibility = function (e) {
        e.stopPropagation();

        const isHidden = menu.getAttribute('aria-hidden') === 'true';

        _toggleMenuVisibility();

        if (isHidden) {
            button.classList.remove(selectors.mobileButtonClosed);
            button.classList.add(selectors.mobileButtonOpen);
            menu.setAttribute('aria-expanded', 'true');
            menu.setAttribute('aria-hidden', 'false');
        } else {
            button.classList.add(selectors.mobileButtonClosed);
            button.classList.remove(selectors.mobileButtonOpen);
            menu.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-hidden', 'true');
        }
    };

    const _closeMobileLoginOptions = () => {
        if (menu.classList.contains(selectors.menuOpen.replace(/\./g,''))) {
            menu.classList.remove(selectors.menuOpen);
            document.querySelector(selectors.mobileButton).classList.remove(selectors.mobileButtonOpen);
            document.querySelector(selectors.mobileButton).classList.add(selectors.mobileButtonClosed);
            menu.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-hidden', 'true');
        }
    };

    const _loopNavigation = (e) => {
        if (e.key == 'Tab' && !e.shiftKey) {
            e.preventDefault();
            firstMenuItem.focus();
        }
    }

    const _loopNavigationReverse = (e) => {
        if (e.key == 'Tab' && e.shiftKey) {
            e.preventDefault();
            lastMenuItem.focus();
        }
    }

    // Handle pressing ESC on the login menu
    const _handleKeyPress = (e) => {
        if (e.key === 'Escape') {
            _closeLoginOptions.call(this, e);
            button.focus();
        }
    }

    // Handle clicking off the login menu
    const _handleClick = (e) => {
        if (!menu.contains(e.target) && !button.contains(e.target)) {
            _closeLoginOptions.call(this, e);
        }
    }

    const _bindEvents = function (el) {
        el.addEventListener('click', _toggleOptionsVisibility);
        lastMenuItem && lastMenuItem.addEventListener("keydown", _loopNavigation)
        firstMenuItem && firstMenuItem.addEventListener("keydown", _loopNavigationReverse)
    };

    const _bindMobileEvents = function (el) {
        el.onclick = _toggleMobileOptionsVisibility;
        document.onclick = _closeMobileLoginOptions;
    };

    return {
        bindEvents: _bindEvents,
        bindMobileEvents: _bindMobileEvents,
    };
};
